import { Box, Typography } from '@mui/material';
import { Address, State } from '@uplift/api';

export type PatientAddressProps = {
  address?: Address;
  state?: State;
  county?: string;
};

export const PatientAddress: React.VFC<PatientAddressProps> = ({ address, state, county }) => {

  if (!address || !state) {
    return null;
  }

  return (
    <Box>
      <Typography>{address.line1}</Typography>
      <Typography>{address.line2}</Typography>
      <Typography>{address.city}, {state.fullName} {address.zip}</Typography>
      {county && <Typography>{county}</Typography>}
    </Box>
  );
};
